import angular from 'angular';

export const componentsModule = angular.module(
  'portainer.kubernetes.react.components',
  []
).name;
